var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

const React = require('react');
const Icon = require('@infotech/uikit-icon').default;

function Svg(props) {
  const svgProps = Object.assign({}, props);
  const title = props.title;
  delete props.title;

  /* <svg {...svgProps} ><title>{title}<title>...</svg> */
  return React.createElement(
    'svg',
    _extends({ width: '24', height: '24', viewBox: '0 0 24 24', focusable: 'false' }, svgProps, { 'aria-labelledby': 'title' }),
    React.createElement(
      'title',
      { id: 'title' },
      title
    ),
    React.createElement('path', { d: 'M6 12v7.234a24.48 24.48 0 0012 0V12H6zm9.723-2l.798-1.382c1.179-2.042.564-4.581-1.34-5.68-1.903-1.1-4.41-.362-5.589 1.68l-.875 1.516a1 1 0 01-1.732-1l.875-1.516c1.721-2.98 5.442-4.075 8.322-2.412 2.879 1.662 3.791 5.432 2.07 8.412l-.22.382H19a1 1 0 011 1v9a1 1 0 01-.725.962 26.48 26.48 0 01-14.55 0A1 1 0 014 20v-9a1 1 0 011-1h10.723zM12 14a1 1 0 011 1v2a1 1 0 01-2 0v-2a1 1 0 011-1zm2 1a1 1 0 01-1 1h-2a1 1 0 010-2h2a1 1 0 011 1z', role: 'presentation' })
  );
}

module.exports = function unlocked(props) {
  return React.createElement(Icon, _extends({ glyph: Svg }, props));
};